export const CONTACT_US_EMAIL = 'support@buddisystems.com'

export const MAIN_PROD_URL = 'https://www.buddisystems.com';

export const SOCIAL_MEDIAS_URLS = {
  FACEBOOK: 'https://www.facebook.com/thebuddisystems',
  INSTAGRAM: 'https://www.instagram.com/buddisystemsinc',
  LINKEDIN: 'https://www.linkedin.com/company/buddisystems-inc',
  YOUTUBE: 'https://www.youtube.com/@buddisystems'
};


export const IS_SHOW_BUDDI_BOT = Boolean(
  process.env.REACT_APP_IS_SHOW_BUDDI_BOT === 'true'
);